import React, { useEffect, useState } from "react";
import Modal from "../common/Modal";
import CustomerFormFields from "./CustomerFormFields";
import {
  EMPTY_CUSTOMER_FORM,
  createAgentCustomer,
  mapCustomerServerError,
  validateCustomerForm,
} from "../../lib/customers";

export default function AddCustomerModal({ open, onClose, onCreated }) {
  const [form, setForm] = useState(EMPTY_CUSTOMER_FORM);
  const [errors, setErrors] = useState({});
  const [formError, setFormError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    setForm(EMPTY_CUSTOMER_FORM);
    setErrors({});
    setFormError("");
    setSaving(false);
    return undefined;
  }, [open]);

  function handleClose() {
    if (saving) return;
    onClose();
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (saving) return;

    const nextErrors = validateCustomerForm(form);
    setErrors(nextErrors);
    setFormError("");
    if (Object.keys(nextErrors).length > 0) return;

    try {
      setSaving(true);
      const { payload, customer } = await createAgentCustomer(form);
      if (typeof onCreated === "function") {
        await onCreated(customer, payload);
      }
    } catch (saveError) {
      const mapped = mapCustomerServerError(saveError);
      setFormError(mapped.formError);
      setErrors((current) => ({ ...current, ...mapped.fieldErrors }));
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal
      open={open}
      title="Add Customer"
      dialogClassName="modal-dialog-scrollable"
      onClose={handleClose}
      footer={(
        <>
          <button type="button" className="btn btn-outline-secondary" disabled={saving} onClick={handleClose}>
            Cancel
          </button>
          <button type="submit" form="add-customer-form" className="btn btn-primary" disabled={saving}>
            {saving ? "Creating..." : "Create Customer"}
          </button>
        </>
      )}
    >
      <form id="add-customer-form" onSubmit={handleSubmit}>
        {formError ? (
          <div className="alert alert-danger bg-danger-100 text-danger-600 border-danger-600 border-start-width-4-px border-top-0 border-end-0 border-bottom-0 px-16 py-12 mb-16 fw-semibold radius-4" role="alert">
            {formError}
          </div>
        ) : null}
        <CustomerFormFields
          form={form}
          errors={errors}
          disabled={saving}
          onChange={setForm}
          autoFocus
          fileInputKey={open ? "open" : "closed"}
        />
      </form>
    </Modal>
  );
}
